import { FC, useState } from "react";

import Modal, { ModalChildrenFnPropsI } from "shared/ui/modal";
import TextArea from "shared/ui/user-input/text-area";
import { useInputValue } from "shared/lib/hooks/use-input-value";
import { clsxMerge } from "shared/lib/helpers";

interface CreateOpportunityModalPropsI {
  onSubmit: (notes: string) => Promise<any>;
}

export const CREATE_OPPORTUNITY_MODAL_ID = "glenx-create-opportunity-modal";

const Textarea = TextArea((props) => <textarea {...props} />);

const CreateOpportunityModalContent: FC<
  CreateOpportunityModalPropsI & ModalChildrenFnPropsI
> = ({ onSubmit, handleClose }) => {
  const [value, onChange] = useInputValue("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);

    const markMeetingResult = await onSubmit(value);

    if (markMeetingResult) {
      handleClose();
    }

    setIsLoading(false);
  };

  return (
    <section className="flex flex-col">
      <Textarea
        name="notes"
        label="Additional notes"
        placeholder="Share more details about your meeting"
        inputProps={{
          value,
          onChange,
        }}
      />

      <div className="flex justify-end gap-2">
        <button
          className={clsxMerge("btn-ae-text", isLoading && "disabled")}
          onClick={handleClose}
        >
          Cancel
        </button>

        <button
          className={clsxMerge(
            "btn-ae-default",
            isLoading && "loading disabled"
          )}
          onClick={handleSubmit}
        >
          Create
        </button>
      </div>
    </section>
  );
};

export const SingleUserLicenseCreatedOpportunityModal: FC<
  CreateOpportunityModalPropsI
> = (props) => (
  <Modal
    id={CREATE_OPPORTUNITY_MODAL_ID}
    title="Opportunity created"
    description="Mark this meeting as an opportunity"
  >
    {(modalProps) => (
      <CreateOpportunityModalContent {...props} {...modalProps} />
    )}
  </Modal>
);
